import React from 'react'
import { Link } from 'react-router-dom'
import { useCartStore } from '~/src/features/cart/stores/useCartStore'
import { useSessionStore } from '~/src/features/account/stores/useSessionStore'
import { useUiStore } from '~/src/shared/stores/useUiStore'

export function ShopShell({ children }) {
  const cart = useCartStore((state) => state.cart)
  const customer = useSessionStore((state) => state.customer)
  const logout = useSessionStore((state) => state.logout)
  const notice = useUiStore((state) => state.notice)

  return (
    <div className="shop-shell">
      <header className="shop-header">
        <div className="shop-header__inner">
          <Link className="shop-logo" to="/">Perfect Scent</Link>
          <nav className="shop-nav">
            <Link to="/">Catalogo</Link>
            <Link to="/carrito">Carrito ({cart.total_items || 0})</Link>
            {customer ? (
              <>
                <Link to="/cuenta">Mi cuenta</Link>
                <button className="shop-link-button" onClick={() => logout()}>Salir</button>
              </>
            ) : (
              <Link to="/cuenta">Mi cuenta</Link>
            )}
          </nav>
        </div>
      </header>
      <main className="shop-main">
        {notice ? <div className="shop-notice">{notice}</div> : null}
        {children}
      </main>
    </div>
  )
}
